import fetch from 'node-fetch';
/**
 * HoneybadgerCheckin is a class that sends a ping to Honeybadger.
 * Honeybadger expects to receive these pings at regular intervals 
 * (the particular interval depends on the type of job).
 * 
 * If the ping is not received, Honeybadger will send an alert to the
 * engineering team.
 */
export class HoneybadgerCheckin {
  /**
   * Send a check-in request to Honeybadger for the provided key.
   * If the environment is not production, this function will do nothing.
   */
  static async checkIn(key: string | undefined) {
    if (!key || process.env.GONDOLA_ENV !== 'production') {
      return;
    }

    const url = `https://api.honeybadger.io/v1/check_in/${key}`;
    await fetch(url);
  }
}
